import React, { useState, useRef, useEffect } from 'react';
import { STATUS_CATEGORIES } from '../../../FlowchartView/TaskNode/constants';
import { generateStatusId, getSuggestedStatusColor, STATUS_COLOR_PRESETS } from '../../../FlowchartView/utils/statusUtils';

/**
 * AddStatusForm Component
 * 
 * Form for adding a new custom status.
 */
const AddStatusForm = ({
  statuses,
  onAddStatus,
  onCancel,
}) => {
  const [newStatusName, setNewStatusName] = useState('');
  const [newStatusCategory, setNewStatusCategory] = useState('in_progress');
  const [newStatusColor, setNewStatusColor] = useState(() => getSuggestedStatusColor(statuses));
  const inputRef = useRef(null);

  // Focus input when form opens
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = () => {
    if (!newStatusName.trim()) return;
    
    const newStatus = {
      id: generateStatusId(newStatusName, statuses),
      name: newStatusName.trim(),
      category: newStatusCategory,
      color: newStatusColor,
      order: statuses.length,
    };
    
    onAddStatus(newStatus);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit();
    if (e.key === 'Escape') onCancel();
  };

  return (
    <div className="status-dropdown__add-form">
      <div className="status-dropdown__add-header">Add Status</div>
      
      <input
        ref={inputRef}
        type="text"
        className="status-dropdown__add-input"
        placeholder="Status name..."
        value={newStatusName}
        onChange={(e) => setNewStatusName(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      
      <div className="status-dropdown__add-label">Category</div>
      <div className="status-dropdown__add-categories">
        {Object.entries(STATUS_CATEGORIES).map(([key, cat]) => (
          <button
            key={key}
            className={`status-dropdown__category-btn ${newStatusCategory === key ? 'status-dropdown__category-btn--active' : ''}`}
            onClick={() => setNewStatusCategory(key)}
            style={{ '--cat-color': cat.color }}
          >
            {cat.label}
          </button>
        ))}
      </div>
      
      <div className="status-dropdown__add-label">Color</div>
      <div className="status-dropdown__add-colors">
        {STATUS_COLOR_PRESETS.map(color => (
          <button
            key={color}
            className={`status-dropdown__color-btn ${newStatusColor === color ? 'status-dropdown__color-btn--active' : ''}`}
            style={{ background: color }}
            onClick={() => setNewStatusColor(color)}
          />
        ))}
      </div>
      
      <div className="status-dropdown__add-actions">
        <button 
          className="status-dropdown__add-cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button 
          className="status-dropdown__add-submit"
          onClick={handleSubmit}
          disabled={!newStatusName.trim()}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AddStatusForm;
